module.exports = __webpack_public_path__ + "static/img/external_link_blk.5f818e6b.svg";